import {t} from "@lingui/core/macro";

import type {passwordChangeMutation_passwordChange_error as PasswordError} from "./__graphql-types__/passwordChangeMutation.ts";

const changePasswordErrorMessage = (error: PasswordError["code"]): string => {
    switch (error) {
        case "UNAUTHORIZED":
            return t`User is not allowed to modify passwords.`;
        case "UNAUTHORIZED_FOR_STUDENT":
            return t`User tried to change password for someone who is not their student.`;
        case "INVALID_INPUT":
            return t`Please enter your existing password`;
        case "TOO_LONG":
            return t`Password is too long.`;
        case "TOO_WEAK":
            return t`Password does not meet strength requirements.`;
        case "CHILD_ACCOUNT":
            return t`Child accounts cannot change passwords.`;
        case "INTERNAL":
        default:
            return t`Oops. Something went wrong. Please try again.`;
    }
};

export default changePasswordErrorMessage;
